<div class="status-report-container">
  <table mat-table [dataSource]="displayRows" class="status-report-table">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Név</th>
      <td mat-cell *matCellDef="let row" [class.total-row]="row.isTotal">{{ row.name }}</td>
    </ng-container>

    @for (column of statusColumns; track column.value) {
      <ng-container [matColumnDef]="column.value">
        <th mat-header-cell *matHeaderCellDef>{{ column.label }}</th>
        <td mat-cell *matCellDef="let row" [class.total-row]="row.isTotal">
          {{ row.counts[column.value] }}
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
